import { useCashDrawerApi } from "../api/CashDrawerApiClient";
import { CashDrawerFrontendService } from "../services/CashDrawerFrontendService";

export const useCashDrawerService = (): CashDrawerFrontendService =>
  new CashDrawerFrontendService(useCashDrawerApi());
